module.exports = __webpack_public_path__ + "img/map-logo.e28c410a.png";